<div class="left-side">
  <h1>Upload Batch</h1>
  <div class="bucket-options">
    <label>Bucket:</label>
    <icn-dropdown
      [(selectedValue)]="selectedStorageOption"
      [position]="'bottom'"
    >
      <icn-dropdown-item
        *ngFor="let option of storageOptions"
        [title]="option.displayName"
        [value]="option"
      >
      </icn-dropdown-item>
    </icn-dropdown>
    <div
      *ngIf="currentUser && currentUser.isSuperUser"
      class="svg-icon-export"
      inlineSVG="/assets/icons/add-account.svg"
      (click)="openNewTenantOptionWizard()"
    ></div>
    <remove-button
      *ngIf="currentUser && currentUser.isSuperUser"
      [overrideClass]="'hover-black'"
      (click)="deleteSelectedOption().then()"
    ></remove-button>
  </div>
  <div>
    <label>Upload Path:</label>
    <input type="text" [(ngModel)]="uploadPath" />
  </div>
  <div class="input-file-container">
    <input
      id="batchFiles"
      class="input-files"
      type="file"
      accept="*"
      multiple
      (change)="onInputFileChange($event)"
    />
    <label for="batchFiles">Choose File</label>
    <button class="btn-clear" (click)="clear()">Clear Finished</button>
  </div>
  <div class="files-status-container">
    <div
      class="file-container"
      *ngFor="let file of uploadService.batchUploadFiles"
    >
      <label class="file-label">{{file.file.name}}</label>
      <label class="file-status-label">{{formatProgress(file)}}</label>
    </div>
  </div>
</div>
<div class="right-side">
  <div class="rules-container">
    <div class="header-container">
      <h1>Batch Rules</h1>
      <div
        class="svg-icon-export"
        inlineSVG="/assets/icons/add-account.svg"
        (click)="openAddRulePopup($event, rulePopover)"
      ></div>
    </div>
    <div class="batch-rules-container">
      <table>
        <tr>
          <th class="check-cell">
            <input
              type="checkbox"
              [checked]="isAllChecked"
              (click)="toggleCheckAll()"
            />
          </th>
          <th class="name-cell">Name</th>
          <th class="rule-cell">Rule</th>
          <th class="type-cell">Type</th>
          <th class="date-cell">Date Created</th>
          <th class="edit-cell">Edit</th>
          <th class="del-cell">Delete</th>
        </tr>
        <tr *ngFor="let rule of rules; let i = index">
          <td class="check-cell">
            <input type="checkbox" [(ngModel)]="rule.selected" />
          </td>
          <td class="name-cell">{{rule.name || 'untitled'}}</td>
          <td class="rule-cell">{{rule.format}}</td>
          <td class="type-cell">{{formatType(rule)}}</td>
          <td class="date-cell">{{formatDate(rule)}}</td>
          <td
            class="edit-cell"
            inlineSVG="/assets/icons/thum-edit.svg"
            (click)="openEditRulePopup($event, rule, rulePopover)"
          ></td>
          <td
            class="del-cell"
            inlineSVG="/assets/icons/thum-trash.svg"
            (click)="onClickDelete(rule)"
          ></td>
        </tr>
      </table>
    </div>
  </div>
  <div class="import-container">
    <h1>Import</h1>
    <div>
      <button class="btn" (click)="checkRules()">Check</button>
      <button *ngIf="showGoButton" class="btn" (click)="go(1)">Go</button>

      <button
        *ngIf="showExistingMediaHandlingButtons"
        class="btn"
        (click)="go(1)"
      >
        Replace
      </button>
      <button
        *ngIf="showExistingMediaHandlingButtons"
        class="btn"
        (click)="go(0)"
      >
        Skip
      </button>
    </div>
    <div class="summary-container">
      <div class="summary" [innerHTML]="summarizeCheckResult(summary)"></div>
    </div>
    <div class="batch-rules-container" *ngIf="summary && summary.length > 0">
      <table>
        <tr>
          <th class="name-cell">Rule</th>
          <th class="name-cell">Status</th>
          <th class="name-cell">Path</th>
          <th class="rule-cell">File Name</th>
          <th class="type-cell">Video ID</th>
          <th class="type-cell">Parent media Id</th>
          <th class="type-cell">Existing media Id</th>
        </tr>
        <tr
          *ngFor="let summaryItem of summary; let i = index"
          [ngStyle]="{
          'backgroundColor' : defineResultRowColor(summaryItem)
          }"
        >
          <td class="name-cell">{{summaryItem.ruleName || 'No Rule'}}</td>
          <td class="rule-cell">{{summaryItem.status}}</td>
          <td class="name-cell">{{summaryItem.bucketPath}}</td>
          <td class="rule-cell">{{summaryItem.fileName}}</td>
          <td class="type-cell">{{summaryItem.parentMediaTenantUniqueId}}</td>
          <td class="date-cell">
            <a
              *ngIf="summaryItem.parentMediaId > 0"
              [routerLink]="'/mam/editMedia/' + summaryItem.parentMediaId"
              [queryParamsHandling]="'preserve'"
              >{{summaryItem.parentMediaId}}</a
            >
          </td>
          <td class="date-cell">
            <a
              [routerLink]="'/mam/editMedia/' + summaryItem.existingMediaId"
              [queryParamsHandling]="'preserve'"
              >{{summaryItem.existingMediaId}}</a
            >
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>
<pop-over #rulePopover>
  <icn-edit-batch-rule
    *ngIf="editedRule"
    [rule]="editedRule"
    (close)="rulePopover.hide()"
  ></icn-edit-batch-rule>
</pop-over>
